import app from "./app";

app
  .component("adminSecurityReport", {
    templateUrl: "securityReportsComponent.html",
    bindings: {
      sections: "<",
      stands: "<",
      managers: "<",
      url: "@",
    },
    controller: function (SecurityReportsPersistence) {
      var self = this;

      function pooling() {
        SecurityReportsPersistence
          .get(self.url)
          .then(({
            updated_at,
            managers,
            sections,
            stands,
          }) => {
            const newUpdatedAt = new Date(updated_at);
            if (self.updatedAt == null || newUpdatedAt >= self.updatedAt) {
              self.updatedAt = newUpdatedAt;
              self.sections = sections;
              self.managers = managers;
              self.stands = stands;
            } else {
              console.warn("Old data arrives");
            }
            return {
              managers,
              sections,
              stands,
            };
          });
      }

      self.startPooling = function () {
        self.liveUpdates = true;
        if (!self.timerId) {
          self.timerId = setInterval(pooling, 5000);
        }
        $(document)
          .off("page:load", self.stopPooling)
          .on("page:load", self.stopPooling);
      };

      self.stopPooling = function () {
        self.liveUpdates = false;
        clearInterval(self.timerId);
        self.timerId = undefined;
      };

      self.sum = function (arr, key) {
        return arr.reduce(function (sum, current) {
          return sum + current[key];
        }, 0);
      };

      self.$onInit = function () {
        self.liveUpdates = false;
      };

      self.$onDestroy = function onDestroy() {
        self.stopPooling();
        $(document)
          .off("page:load", self.stopPooling);
      };

      self.formatTime = function (date) {
        if (date == null) return "";
        return `${date.getHours()}:${date.getMinutes()}:${("0" + date.getSeconds()).slice(-2)}`;
      };
    },
  });
